var map = {
	"./arrow.svg": 55102,
	"./bloodPressure.svg": 1521,
	"./buy-arrow.svg": 30050,
	"./calendar.svg": 63850,
	"./category-icon.svg": 13861,
	"./close-icon.svg": 96014,
	"./facialSkinAge.svg": 30036,
	"./general-wellness.svg": 88700,
	"./generalWellness.svg": 67988,
	"./go-multi-vitamin.svg": 30004,
	"./heartRate.svg": 82396,
	"./hrvSdnn.svg": 14532,
	"./ibi.svg": 1618,
	"./lightbulb.svg": 61355,
	"./location.svg": 92310,
	"./panoptic.svg": 84525,
	"./right-arrow.svg": 87882,
	"./stress-top.svg": 53843,
	"./stress.svg": 97416
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 70986;